import {Form, Input, Row, UploadFile} from "antd";
import Uploader from "../../../uploader/Uploader";
import * as BUCKETS from "../../../../enums/buckets";
import {EmployeeFormData, EmployeeFormProps} from "./types";
import "./style.less"
import {useEffect, useState} from "react";
import {getImageLink} from "../../../../helpers/mainHelpers";
import TextEditor from "../../../text-editor/TextEditor";

const EmployeeForm = (props: EmployeeFormProps) => {
  const {employeeController, employeeType} = props
  const {form, onFormSubmit, selectedEmployee} = employeeController
  const [details, setDetails] = useState("")
  const [employeeImage, setEmployeeImage] = useState<UploadFile[]>([])
  const [aboutEmployee, setAboutEmployee] = useState(selectedEmployee?.about)

  useEffect(() => {
    if (selectedEmployee) {
      const employeeImage = {
        uid: selectedEmployee.image,
        name: "image",
        url: getImageLink({imageId: selectedEmployee.image, bucketId: BUCKETS.MAIN}),
        response: {$id: selectedEmployee.image}
      }
      setEmployeeImage([employeeImage])

    } else {
      setEmployeeImage([])
    }
  }, [selectedEmployee])

  const formFinishHandler = (formData: EmployeeFormData) => {
    if (employeeImage?.length) {
      const data = {
        ...formData,
        image: employeeImage[0].response.$id || "",
        type: employeeType,
        about: aboutEmployee || ""
      }
      onFormSubmit(data)
    }
  }


  return <Form form={form} layout="vertical" className="employee_form" onFinish={formFinishHandler}>
    <Row>
      <Form.Item label="Фото">
        <Uploader maxCount={1} bucketId={BUCKETS.MAIN} files={employeeImage} setFiles={setEmployeeImage}/>
      </Form.Item>
    </Row>
    <Form.Item name="fullName" label="ПІБ" rules={[{required: true}]}>
      <Input/>
    </Form.Item>
    <Form.Item name="position" label="Посада" rules={[{required: true}]}>
      <Input/>
    </Form.Item>
    <Form.Item name="about" label="Детальна інформація">
      <TextEditor value={aboutEmployee} setValue={setAboutEmployee}/>
    </Form.Item>
  </Form>
}

export default EmployeeForm